import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

const getAttribution = () => {
  const p = new URLSearchParams(window.location.search);
  return {
    utm_source: p.get("utm_source"), utm_medium: p.get("utm_medium"),
    utm_campaign: p.get("utm_campaign"), utm_content: p.get("utm_content"),
    utm_term: p.get("utm_term"), fbclid: p.get("fbclid"), gclid: p.get("gclid"),
    pageUrl: window.location.href, referrer: document.referrer || null,
  };
};

export const RegForm = ({ t, lang, idPrefix }) => {
  const navigate = useNavigate();
  const attribution = useMemo(getAttribution, []);
  const [form, setForm] = useState({ firstName: "", lastName: "", email: "", phone: "", state: "", journey: "" });
  const [consent, setConsent] = useState(false);
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState("");

  const f = t.form;
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!form.firstName || !form.lastName || !form.email || !form.phone || !form.state) {
      setError(f.errors.required);
      return;
    }
    if (!consent) {
      setError(f.errors.consent);
      return;
    }
    setStatus("loading");
    try {
      await axios.post(`${API}/api/ghl-lead`, {
        ...form,
        journey: form.journey || null,
        consent: true,
        consentText: f.consent,
        language: lang,
        ...attribution,
      });
      setStatus("success");
      navigate("/thank-you");
    } catch (err) {
      setStatus("idle");
      setError(err?.response?.data?.detail || f.errors.server);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-3" data-testid={`${idPrefix}-form`}>
      <div className="grid grid-cols-2 gap-3">
        <input data-testid={`${idPrefix}-first-name-input`} className="field" placeholder={f.firstName} value={form.firstName} onChange={set("firstName")} />
        <input data-testid={`${idPrefix}-last-name-input`} className="field" placeholder={f.lastName} value={form.lastName} onChange={set("lastName")} />
      </div>
      <input data-testid={`${idPrefix}-email-input`} className="field" type="email" placeholder={f.email} value={form.email} onChange={set("email")} />
      <input data-testid={`${idPrefix}-phone-input`} className="field" type="tel" placeholder={f.phone} value={form.phone} onChange={set("phone")} />
      <select data-testid={`${idPrefix}-state-select`} className="field" value={form.state} onChange={set("state")}>
        <option value="">{f.state}</option>
        {f.states.map((s) => <option key={s} value={s}>{s}</option>)}
      </select>
      <select data-testid={`${idPrefix}-journey-select`} className="field" value={form.journey} onChange={set("journey")}>
        <option value="">{f.journey}</option>
        {f.journeys.map((s) => <option key={s} value={s}>{s}</option>)}
      </select>
      <label className="flex items-start gap-3 pt-1">
        <input
          data-testid={`${idPrefix}-consent-checkbox`}
          type="checkbox"
          checked={consent}
          onChange={(e) => setConsent(e.target.checked)}
          className="mt-0.5 accent-[#4D9FFF] w-4 h-4 shrink-0"
        />
        <span className="text-[10px] leading-relaxed text-white/35">{f.consent}</span>
      </label>
      {error && <div data-testid={`${idPrefix}-form-error`} className="text-red-400 text-xs mono">{error}</div>}
      <button
        data-testid={`${idPrefix}-submit-button`}
        type="submit"
        disabled={status === "loading"}
        className="btn-accent w-full py-4 text-sm tracking-widest uppercase disabled:opacity-60"
      >
        {status === "loading" ? f.submitting : f.submit}
      </button>
      <p className="text-[10px] text-white/25 text-center pt-1">{t.card.trust}</p>
    </form>
  );
};
